export const createAddBulkAutoPlugCommentRequest = (post_id, comments) => {
  return {
    url: "/auto_plug_comments/bulk_create",
    method: "POST",
    data: {
      post_id,
      comments
    }
  };
};

export const createUpdateBulkAutoPlugCommentRequest = (comments) => {
  return {
    url: "/auto_plug_comments/bulk_update",
    method: "PUT",
    data: {
      comments
    }
  };
};

export const createDeleteBulkAutoPlugCommentRequest = (comments) => {
  return {
    url: "/auto_plug_comments/bulk_delete",
    method: "DELETE",
    data: {
      comments
    }
  };
};

export const createGetCustomAutoPlugCommentsRequest = (disableLoading = false) => {
  return {
    url: "/custom_auto_plug_comments",
    method: "GET",
    disableLoading,
  };
};

export const createSaveCustomAutoPlugCommentRequest = (content) => {
  return {
    url: "/custom_auto_plug_comments",
    method: "POST",
    disableLoading: true,
    data: {
      content: content,
    },
  };
};

export const createUpdateCustomAutoPlugCommentRequest = (id, content) => {
  return {
    url: "/custom_auto_plug_comments/" + id,
    method: "PUT",
    data: {
      content: content,
    },
  };
};

export const createDeleteCustomAutoPlugCommentRequest = (id) => {
  return {
    url: "/custom_auto_plug_comments/" + id,
    method: "DELETE",
  };
};

// Org-scoped Auto Plug Comments
export const createOrgAddBulkAutoPlugCommentRequest = (post_id, comments, workspaceId) => {
  return {
    url: "/orgs/auto_plug_comments/bulk_create",
    method: "POST",
    params: { workspace_id: workspaceId },
    data: {
      post_id,
      comments
    }
  };
};

export const createOrgUpdateBulkAutoPlugCommentRequest = (comments, workspaceId) => {
  return {
    url: "/orgs/auto_plug_comments/bulk_update",
    method: "PUT",
    params: { workspace_id: workspaceId },
    data: {
      comments
    }
  };
};

export const createOrgDeleteBulkAutoPlugCommentRequest = (comments, workspaceId) => {
  return {
    url: "/orgs/auto_plug_comments/bulk_delete",
    method: "DELETE",
    params: { workspace_id: workspaceId },
    data: {
      comments
    }
  };
};

export const createGetOrgCustomAutoPlugCommentsRequest = (workspaceId, disableLoading = false) => {
  return {
    url: "/orgs/custom_auto_plug_comments",
    method: "GET",
    params: { workspace_id: workspaceId },
    disableLoading,
  };
};

export const createSaveOrgCustomAutoPlugCommentRequest = (content, workspaceId) => {
  return {
    url: "/orgs/custom_auto_plug_comments",
    method: "POST",
    params: { workspace_id: workspaceId },
    data: {
      content: content,
    },
  };
};

export const createUpdateOrgCustomAutoPlugCommentRequest = (id, content, workspaceId) => {
  return {
    url: "/orgs/custom_auto_plug_comments/" + id,
    method: "PUT",
    params: { workspace_id: workspaceId },
    data: {
      content: content,
    },
  };
};

export const createDeleteOrgCustomAutoPlugCommentRequest = (id, workspaceId) => {
  return {
    url: "/orgs/custom_auto_plug_comments/" + id,
    method: "DELETE",
    params: { workspace_id: workspaceId },
  };
};
